/*
 * delivery-matrix.js — 배송 추정 [데이터 계층]
 * ---------------------------------------------------------------------------
 * 배송 프로필에서 도출된 zone 중심 매트릭스(shop 메타필드 custom.delivery_matrix)를
 * 파싱하고, 국가 코드로 배송 범위를 조회(lookup)한다. 매트릭스가 없으면 테마 설정의
 * economy-only 배열 맵(country_ship_range_json) → 기본일×배수 순으로 강등한다.
 *
 * 계층: [데이터] delivery-matrix ─ [계산] delivery-estimate ─ [UI] delivery-estimate-ui
 * lookup(country) → { economy:{min,max}, express:{min,max,price,currency}|null, source }
 */
window.WookieDelivery = window.WookieDelivery || {};
(function (NS) {
  'use strict';

  // 매트릭스 원문은 layout/theme.liquid 가 페이지당 1회 #delivery-matrix-data 로 내보낸다.
  // DOM 읽기는 데이터 계층인 여기서 한 번만 하고, 컨텍스트/UI 계층은 이 값을 공유한다
  // (예전엔 상품페이지가 data-matrix 로 같은 3.8KB 를 중복 출력했다).
  if (NS.matrixRaw == null) {
    var _el = document.getElementById('delivery-matrix-data');
    NS.matrixRaw = (_el && _el.textContent) || '';
  }

  function safeParse(raw, fallback) {
    try { return JSON.parse(raw); } catch (e) { return fallback; }
  }
  function r0(n) { return Math.max(1, Math.round(n)); }
  function normRange(o) {
    var mn = r0(o.min);
    return { min: mn, max: Math.max(mn, Math.round(o.max)) };
  }
  function normExpress(o) {
    var r = normRange(o);
    if (o.price != null) r.price = o.price;
    if (o.currency) r.currency = o.currency;
    return r;
  }
  function normEconomy(o) {
    var r = normRange(o);
    if (o.free_over != null) r.free_over = o.free_over; // 무료배송 최소 주문금액
    if (o.currency) r.currency = o.currency;
    return r;
  }

  // opts: { matrixRaw, rangeRaw, defaultDays, minPercent, maxPercent }
  function create(opts) {
    opts = opts || {};
    var matrix = safeParse(opts.matrixRaw || '{}', {}) || {};
    var zones = matrix.zones || {};
    var countries = matrix.countries || {};
    var range = safeParse(opts.rangeRaw || '{}', {}) || {};
    var def = Math.max(1, parseInt(opts.defaultDays, 10) || 14);
    var minP = parseFloat(opts.minPercent) || 85;
    var maxP = parseFloat(opts.maxPercent) || 115;

    function lookup(country) {
      var c = (country || '').toUpperCase();
      var slug = countries[c];
      if (slug && zones[slug] && zones[slug].economy) {
        var z = zones[slug];
        return {
          economy: normEconomy(z.economy),
          express: z.express ? normExpress(z.express) : null,
          source: 'matrix'
        };
      }
      if (range[c] && range[c].length === 2) {
        return { economy: { min: r0(range[c][0]), max: r0(range[c][1]) }, express: null, source: 'range' };
      }
      // 기본일을 배수로 펼쳐 range 산출(기존 폴백 동작 유지)
      var lo = Math.max(1, Math.floor(def * (minP / 100)));
      var hi = Math.max(lo, Math.ceil(def * (maxP / 100)));
      return { economy: { min: lo, max: hi }, express: null, source: 'default' };
    }

    // 국가 셀렉터용: 매트릭스 + 폴백 맵의 국가 코드 합집합
    function allCountryCodes() {
      var set = {};
      Object.keys(countries).forEach(function (c) { set[c] = 1; });
      Object.keys(range).forEach(function (c) { set[c] = 1; });
      return Object.keys(set);
    }

    return { lookup: lookup, allCountryCodes: allCountryCodes, hasMatrix: Object.keys(countries).length > 0 };
  }

  NS.Matrix = { create: create };
})(window.WookieDelivery);
